/**
 * VELKSIA — le titre de la page d'accueil se déplie.
 *
 * La premiere ligne ne bouge pas : c'est la signature.
 * La seconde vit dans une fenetre d'UNE ligne, hauteur bloquee, dans laquelle
 * les variantes montent l'une apres l'autre, puis la boucle revient au debut.
 * Hauteur bloquee = le sous-titre et le bouton ne bougent jamais d'un pixel.
 *
 * La liste des mots vient du snippet velksia-hero-titre.liquid : pour la
 * changer, il n'y a que cette ligne-la a toucher, pas ce fichier.
 *
 * Trois precautions :
 *   . la hauteur de ligne est MESUREE sur le titre reel, jamais devinee, donc
 *     le bloc suit la taille de police que le theme applique a chaque largeur.
 *   . si le mot le plus long depasse la largeur disponible, la taille du titre
 *     est reduite juste ce qu'il faut : un mot coupe serait invisible a l'oeil
 *     du developpeur et bien visible pour le client.
 *   . animation desactivee pour qui a coupe les animations : la premiere
 *     variante reste affichee, le titre se lit en entier.
 *
 * Sans JavaScript, le titre d'origine reste affiche tel quel.
 */
(function () {
  var CFG = document.getElementById('vlk-htitre');
  if (!CFG) return;

  var FIXE = CFG.getAttribute('data-fixe') || '';
  var MOTS = (CFG.getAttribute('data-mots') || '').split('|').filter(function (m) {
    return m.trim() !== '';
  });
  var SECONDES_PAR_MOT = parseFloat(CFG.getAttribute('data-duree')) || 3.2;
  if (MOTS.length < 2) return;

  var h1 = null;
  var lhBase = 0;
  var fsBase = '';

  /*
    Les etapes dependent du nombre de mots : on ecrit l'animation a la volee
    pour que la liste reste modifiable sans retoucher le CSS.

    Le mot s'efface pendant qu'il glisse, et revient une fois pose. Sans ce
    creux, le demi-mot sortant et le demi-mot entrant restent parfaitement
    lisibles pendant la demi-seconde du mouvement : on lit deux bouts de
    phrase en meme temps, et ca fait brouillon. Avec, on voit un changement,
    pas deux lettres coupees.
  */
  function etapes(n) {
    var pas = 100 / (n + 1); /* une piste de plus : la reprise du premier mot */
    var tenue = 100 / n;
    var glissement = 3.4;
    var creuxOpacite = 0.2;
    var k = '';
    for (var i = 0; i < n; i++) {
      var debut = i * tenue;
      var fin = debut + tenue - glissement;
      var creux = fin + glissement / 2;
      k += debut.toFixed(3) + '%,' + fin.toFixed(3) + '%{transform:translateY(-' + (i * pas).toFixed(4) + '%);opacity:1}';
      k += creux.toFixed(3) + '%{opacity:' + creuxOpacite + '}';
    }
    k += '100%{transform:translateY(-' + (n * pas).toFixed(4) + '%);opacity:1}';
    return '@keyframes vlkHtitre{' + k + '}';
  }

  function injecterEtapes(n) {
    var s = document.getElementById('vlk-htitre-kf');
    if (!s) {
      s = document.createElement('style');
      s.id = 'vlk-htitre-kf';
      document.head.appendChild(s);
    }
    s.textContent = etapes(n);
  }

  function mesurer() {
    if (!h1) return;
    var cs = window.getComputedStyle(h1);
    h1.style.fontSize = '';
    var lh = parseFloat(cs.lineHeight);
    if (!lh || isNaN(lh)) lh = parseFloat(cs.fontSize) * 1.15;
    lhBase = lh;
    fsBase = cs.fontSize;
    poserHauteurs(lh);

    /* Le mot le plus long doit tenir sur une ligne, sinon il serait coupe. */
    var fenetre = h1.querySelector('.vlk-htitre__roule');
    if (!fenetre) return;
    var dispo = fenetre.clientWidth;
    var plusLarge = 0;
    var mots = h1.querySelectorAll('.vlk-htitre__mot');
    for (var i = 0; i < mots.length; i++) {
      if (mots[i].scrollWidth > plusLarge) plusLarge = mots[i].scrollWidth;
    }
    if (dispo > 0 && plusLarge > dispo) {
      var r = Math.max(0.72, dispo / plusLarge);
      h1.style.fontSize = 'calc(' + fsBase + ' * ' + r.toFixed(3) + ')';
      poserHauteurs(lhBase * r);
    }
  }

  /*
    La fenetre est plus haute que la ligne d'environ un cinquieme, et remontee
    d'autant en CSS : Cormorant dessine sur 1,16 em, donc l'encre d'un mot
    deborde de sa propre ligne. Sans cette marge, le jambage du mot precedent
    restait visible en haut du cadre.
  */
  function poserHauteurs(lh) {
    h1.style.setProperty('--vlk-htitre-lh', lh + 'px');
    h1.style.setProperty('--vlk-htitre-pad', Math.round(lh * 0.22) + 'px');
  }

  function poser() {
    var cible = document.querySelector('.hero__container h1') || document.querySelector('.hero h1');
    if (!cible || cible.getAttribute('data-vlk-htitre')) return !!cible;

    cible.setAttribute('data-vlk-htitre', '1');
    h1 = cible;

    var fixe = document.createElement('span');
    fixe.className = 'vlk-htitre__fixe';
    fixe.textContent = FIXE;

    var fenetre = document.createElement('span');
    fenetre.className = 'vlk-htitre__roule';

    var piste = document.createElement('span');
    piste.className = 'vlk-htitre__piste';
    piste.style.animationDuration = MOTS.length * SECONDES_PAR_MOT + 's';

    var liste = MOTS.concat([MOTS[0]]); /* reprise : la boucle se referme sans saut */
    for (var i = 0; i < liste.length; i++) {
      var mot = document.createElement('span');
      mot.className = 'vlk-htitre__mot';
      mot.textContent = liste[i];
      /* Un lecteur d'ecran doit entendre le titre une fois, pas cinq. */
      if (i !== 0) mot.setAttribute('aria-hidden', 'true');
      piste.appendChild(mot);
    }

    fenetre.appendChild(piste);
    cible.textContent = '';
    cible.appendChild(fixe);
    cible.appendChild(fenetre);
    cible.classList.add('vlk-htitre');

    injecterEtapes(MOTS.length);
    mesurer();
    programmerMesures();
    return true;
  }

  /*
    Cormorant arrive apres le premier rendu et elargit les mots : une mesure
    unique tomberait sur la police de secours, plus etroite, et conclurait a
    tort que tout tient. On repasse donc quelques fois.
  */
  function programmerMesures() {
    window.setTimeout(mesurer, 300);
    window.setTimeout(mesurer, 900);
    window.setTimeout(mesurer, 2200);
  }

  var attente = null;
  function surRedimensionnement() {
    if (attente) window.clearTimeout(attente);
    attente = window.setTimeout(function () {
      attente = null;
      mesurer();
    }, 160);
  }

  function demarrer() {
    if (!poser() && window.MutationObserver) {
      /* Le theme peut reconstruire la section apres coup (editeur, navigation). */
      var obs = new MutationObserver(function () {
        if (poser()) obs.disconnect();
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
      window.setTimeout(function () { obs.disconnect(); }, 10000);
    }
    window.addEventListener('resize', surRedimensionnement);
    window.addEventListener('orientationchange', surRedimensionnement);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(mesurer);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
